import { createSlice } from "@reduxjs/toolkit";
import axios from "../../services/authService";
import { API_ENDPOINTS } from '../../config/apiConfig';

export const deleteFlowSlice = createSlice({
    name: "deleteFlow",
    initialState: {
        loading: false,
        response: {},
        error: null
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.response = {};
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    reset,
    setLoading,
    setResponse,
    setError
} = deleteFlowSlice.actions;

/**
 * Delete a flow from the database (backend cascades to events/scenarios/attributes)
 * @param {number} flowDbId - The database ID of the flow to delete
 */
export const deleteFlowAsync = (flowDbId) => async (dispatch) => {
    dispatch(reset());
    dispatch(setLoading(true));

    try {
        // Build the URL with query parameter
        const url = `${API_ENDPOINTS.DELETE_EVENT_OR_FLOW}?test_flow_id=${flowDbId}`;

        // Make the DELETE request
        const response = await axios.delete(url);

        dispatch(setResponse({
            message: "Flow deleted successfully",
            data: response.data
        }));

        return {
            success: true,
            data: response.data
        };

    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || "Failed to delete flow";
        console.error("Error deleting flow:", errorMessage);
        dispatch(setError(errorMessage));
        return {
            success: false,
            error: errorMessage
        };
    }
};

// Selectors
export const selectDeleteFlowLoading = (state) => state.deleteFlow.loading;
export const selectDeleteFlowResponse = (state) => state.deleteFlow.response;
export const selectDeleteFlowError = (state) => state.deleteFlow.error;

export default deleteFlowSlice.reducer;
